import { useCallback } from 'react';
import useAxios from 'axios-hooks';
import {
  CurrencyAmounts,
  RatesEditPayload,
  RatesFormPayload,
  RatesParams,
} from './rates.types';

export const useGetStormRateById = () => {
  const [{ data, loading }, getStormRateReq] = useAxios({
    method: 'GET',
  });

  const getStormRateById = useCallback(
    (id: string) => {
      return getStormRateReq({
        url: `/backend/service/storm-rate/${id}`,
      });
    },
    [getStormRateReq],
  );

  return {
    data: data?.result,
    loading,
    getStormRateById,
  };
};

export const usePublishStormRate = () => {
  const [{ loading }, publishStormRateReq] = useAxios({
    method: 'PATCH',
  });

  const publishStormRate = useCallback(
    (rateId: string) => {
      return publishStormRateReq({
        url: `/backend/service/storm-rate/${rateId}/status?status=PUBLISHED`,
      });
    },
    [publishStormRateReq],
  );

  return {
    loading,
    publishStormRate,
  };
};

export const useDraftStormRate = () => {
  const [{ loading }, draftStormRateReq] = useAxios({
    method: 'PATCH',
  });

  const draftStormRate = useCallback(
    (rateId: string) => {
      return draftStormRateReq({
        url: `/backend/service/storm-rate/${rateId}/status?status=DRAFT`,
      });
    },
    [draftStormRateReq],
  );

  return {
    loading,
    draftStormRate,
  };
};

export const useDeleteStormRate = () => {
  const [{ loading }, deleteStormRateReq] = useAxios({
    method: 'DELETE',
  });

  const deleteStormRate = useCallback(
    (rateId: string) => {
      return deleteStormRateReq({
        url: `/backend/service/storm-rate/${rateId}`,
      });
    },
    [deleteStormRateReq],
  );

  return {
    loading,
    deleteStormRate,
  };
};

export const useUpdateStormRate = () => {
  const [{ data, loading }, updateStormRateReq] = useAxios({
    method: 'PUT',
  });

  const updateStormRate = useCallback(
    (rateId: string, payload: RatesEditPayload | RatesFormPayload) => {
      return updateStormRateReq({
        url: `/backend/service/storm-rate/${rateId}/stormRate`,
        data: payload,
      });
    },
    [updateStormRateReq],
  );

  return {
    data: data?.result,
    loading,
    updateStormRate,
  };
};

export const useGetStormRates = () => {
  const [{ data, loading }, getStormRatesReq] = useAxios({
    method: 'GET',
  });

  const getStormRates = useCallback(
    (params: RatesParams) => {
      return getStormRatesReq({
        url: '/backend/service/storm-rate',
        params,
      });
    },
    [getStormRatesReq],
  );

  return {
    data: data?.result,
    loading,
    getStormRates,
  };
};

export const useCreateStormRate = () => {
  const [{ data, loading }, createStormRateReq] = useAxios({
    method: 'POST',
  });

  const createStormRate = useCallback(
    (payload: RatesFormPayload) => {
      return createStormRateReq({
        url: '/backend/service/storm-rate/create-storm-rates',
        data: payload,
      });
    },
    [createStormRateReq],
  );

  return {
    data: data?.result,
    loading,
    createStormRate,
  };
};

export const useCalculateStormRate = () => {
  const [{ data, loading }, calculateStormRateReq] = useAxios({
    method: 'POST',
  });

  const calculateStormRate = useCallback(
    (payload: { currencyAmounts: CurrencyAmounts }) => {
      return calculateStormRateReq({
        url: '/backend/service/storm-rate/calculate',
        data: payload,
      });
    },
    [calculateStormRateReq],
  );

  return {
    data: data?.result,
    loading,
    calculateStormRate,
  };
};
